<template>
  <div id="pdv-import-history">
    <smart-container>
      <smart-title heading="1" weight="medium" class="title"
        >Importações</smart-title
      >
      <span class="subtitle"
        >Escolha os filtros para visualizar as informações.</span
      >

      <div class="filters-wrapper mt-3">
        <v-text-field
          @onChange="searchTable"
          v-model="search"
          class="text-field relative search"
          placeholder="Digite o nome da tabela"
          id="searchInput"
        />

        <history-filter
          @skeleton-handler="skeletonHandler"
          @save-filter="saveFilter"
        />
      </div>

      <div v-if="!loading" class="align-start mt-4">
        <VDataTable
          :headers="headers"
          :items="list"
          hide-actions
          class="elevation-1 mt-1 history-table"
          :class="{ loading: false }"
          no-data-text="Não há dados a serem exibidos"
        >
          <template v-slot:items="{ item }">
            <td class="limited-info-style limited-width">
              <span>{{ item.registration || "teste registration" }}</span>
            </td>
            <td class="limited-info-style limited-width">
              <span>{{ item.sendDate || "data" }}</span>
            </td>
            <td class="limited-info-style limited-width">
              {{ item.channel || "data" }}
            </td>
            <td class="limited-info-style limited-width">
              <span>{{ item.fileName }}</span>
            </td>
            <td class="limited-info-style limited-width">
              <span>{{ item.sendDate || "data" }}</span>
            </td>
            <td class="limited-info-style limited-width">
              <span
                v-if="item.status == 'Sucesso'"
                class="status-area status-sucess"
                >{{ item.status || "status" }}</span
              >
              <span
                v-else-if="item.status == 'Erro'"
                class="status-area status-error"
                >{{ item.status || "status" }}</span
              >
              <span
                v-else-if="item.status == 'Processado'"
                class="status-area status-processed"
                >{{ item.status || "status" }}</span
              >
              <span
                v-else-if="item.status == 'Aguardando processamento'"
                class="status-area status-processing"
                >{{ item.status || "status" }}</span
              >
            </td>
            <!-- <td class="view-icon" width="100">
              <label
                class="flex flex-row align-center justify-center cursor-pointer"
              >
                <SmartIcon
                  @click="downloadModel(item.id)"
                  type="small"
                  :size="2"
                  name="view"
                  class="mr-1-2"
                />
              </label>
            </td> -->
          </template>
        </VDataTable>
      </div>
      <SmartCard class="mt-4 p-3" v-else>
        <SmartSkeletonLoading :items="11" :height="4" />
      </SmartCard>
    </smart-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import { createLink } from "utils/blob";

export default {
  components: {
    HistoryFilter: () => import("./components/HistoryFilter.vue"),
  },
  mixins: [clickaway],
  data() {
    return {
      type: "",
      showModal: false,
      list: [],
      search: "",
      pdfURL: "",
      pdfContent: "",
      currentFilter: {},
      loading: false,
      loadingCoverSheet: false,
      headers: [
        { text: "Matrícula", value: "", sortable: false },
        { text: "Data da Solicitação", value: "", sortable: false },
        { text: "Canal", value: "", sortable: false },
        { text: "Arquivo", value: "", sortable: false },
        { text: "Data Referência", value: "", sortable: false },
        { text: "Status", value: "status", sortable: false },
        // { text: "", value: "", sortable: false },
      ],
      isAllPeriodsSelected: false,
      page: 1,
    };
  },
  watch: {
    search(value) {
      if (value) {
        this.list = this.list.filter(
          (item) =>
            item.name.toLowerCase().includes(this.search.toLowerCase()) ||
            String(item.id).includes(this.search)
        );
      } else {
        const DTO = {
          ...this.filter,
          pageNumber: this.page,
        };
        this.fetchHistoryList({ DTO });
      }
    },
    isAllPeriodsSelected(value) {
      if (value) {
        return this.toggleAll();
      }
      return this.unToggleAll();
    },
    historyListGetter(updatedList) {
      if (updatedList.data.data) {
        this.list = updatedList.data.data.map((item) => ({
          registration: item.registration,
          sendDate: item.sendDate,
          channel: item.channel,
          fileName: item.fileName,
          status:
            item.status == "RECEIVED"
              ? (item.status = "Sucesso")
              : item.status == "ERROR"
              ? (item.status = "Erro")
              : item.status == "PROCESSED"
              ? (item.status = "Processado")
              : item.status == "PROCESSING"
              ? (item.status = "Aguardando processamento")
              : item.status,
        }));
        this.isAllPeriodsSelected = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      historyListGetter: "pdvImportHistory/historyList",
    }),
    currentPage() {
      return this.pagination.current_page;
    },
    length() {
      return this.pagination.last_page;
    },
    canExport() {
      if (this.list.some((item) => item.active)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      fetchHistoryList: "pdvImportHistory/fetchHistoryList",
    }),
    searchTable(text) {
      this.search = text;
    },
    openModal() {
      this.showModal = true;
    },
    closeShower() {
      this.pdfURL = "";
    },
    hideModal() {
      this.showModal = false;
    },
    saveFilter(filter) {
      this.currentFilter = { ...filter };
    },
    skeletonHandler(state) {
      this.loading = state;
    },
    async changePage() {
      const filter = this.currentFilter;
      const DTO = {
        ...filter,
        pageNumber: this.page,
      };
      this.loading = true;
      // await this.fetchHistoryList({ DTO });
      this.loading = false;
    },
  },
  // mounted() {
  //   const DTO = {
  //     pageNumber: 1,
  //   };
  //   this.loading = true;
  //   this.fetchHistoryList({ DTO }).then(() => {
  //     this.list = this.historyListGetter.data.map((item) => ({
  //       id: item.id,
  //       sendDate: item.sendDate,
  //       channel: item.channel,
  //       fileName: item.fileName,
  //       status: item.user_registration,
  //     }));
  //     this.loading = false;
  //   });
  // },
};
</script>

<style lang="scss">
#pdv-import-history {
  // ---------------------------------------- new layout

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  label {
    font-family: "Nunito", sans-serif !important;
  }

  .smart__title--h1 {
    margin-left: 0;
  }

  .title {
    font-size: 24px;
  }

  .subtitle {
    font-size: 16px;
    color: #8598ad;
  }

  .search input {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 80px 8px 8px;
    gap: 4px;

    width: 300px;
    height: 42px;

    background: #ffffff;
    box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.08),
      0px 1px 4px rgba(0, 0, 0, 0.04);
    border-radius: 16px;

    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .history-table {
    thead {
      background-color: #cfe5fc;

      th {
        color: #0f4a8a;
      }
    }

    td {
      height: 74px;
    }
  }

  .status-area {
    padding: 5px 10px 5px 10px;
    border-radius: 36px;
    font-weight: 600;
    padding: 2px 16px;
  }

  .status-sucess {
    background: #cffcde;
    color: #0a5c25;
  }

  .status-error {
    background: #fccfcf;
    color: #f20d0d;
  }

  .status-processed {
    background: #cfe5fc;
    color: #053161;
  }

  .status-processing {
    background: #fcedcf;
    color: #614205;
  }

  // ----------------------------------------

  .v-text-field__slot {
    background: #fff;
  }
  .header__wrapper {
    z-index: 100;
  }
  .text-field {
    max-width: 288px;

    input {
      max-width: 288px;
    }
  }
  .checkbox-all__wrapper--helper {
    max-width: 355px;
  }

  .filters-wrapper {
    display: flex;
  }
}
</style>
